import { Dropdown } from "@jetblue/kit/dropdown";
import { Incrementer } from "@jetblue/kit/incrementer";

import type { FlightSearchFormLabels } from "../../labels";
import {
  MAX_CHILDREN_WITHOUT_ADULT,
  type PassengersControl,
} from "../../use-passengers";

import { passengersDropdownLabel } from "./label";

export type PassengersDropdownProperties = {
  controlAdults: PassengersControl;
  controlChildren: PassengersControl;
  controlInfants: PassengersControl;
  labels: FlightSearchFormLabels["passengersDropdown"];
};
export const PassengersDropdown = ({
  controlAdults,
  controlChildren,
  controlInfants,
  labels,
}: PassengersDropdownProperties) => {
  const adultsCount = controlAdults.value;
  const childrenCount = controlChildren.value;
  const infantsCount = controlInfants.value;

  const label = passengersDropdownLabel({
    adultsCount,
    childrenCount,
    infantsCount,
    labels,
  });

  const adultLabel = " " + labels.adult.toLowerCase();
  const childLabel = " " + labels.child.toLowerCase();
  const infantLabel = " " + labels.infant.toLowerCase();

  return (
    <>
      <input
        className="hidden"
        name="adults"
        readOnly
        type="number"
        value={controlAdults.value}
      />
      <input
        className="hidden"
        name="children"
        readOnly
        type="number"
        value={controlChildren.value}
      />
      <input
        className="hidden"
        name="infants"
        readOnly
        type="number"
        value={controlInfants.value}
      />
      <Dropdown contentClassName="rounded-t-none max-w-[395px]" label={label}>
        <div>
          <div className="flex justify-between border-b border-light-gray pb-4">
            <div className="mr-4 min-w-40">{labels.adultsRestrictions}</div>
            <Incrementer
              decrement={controlAdults.decrement}
              decrementLabel={labels.decrement + adultLabel}
              increment={controlAdults.increment}
              incrementLabel={labels.increment + adultLabel}
              isDecrementDisabled={controlAdults.isDecrementDisabled}
              isIncrementDisabled={controlAdults.isIncrementDisabled}
              name="adults"
              value={controlAdults.value}
            />
          </div>
          <div className="mt-4 flex justify-between border-b border-light-gray pb-4">
            <div className="mr-4 min-w-40">{labels.childrenRestrictions}</div>
            <Incrementer
              decrement={controlChildren.decrement}
              decrementLabel={labels.decrement + childLabel}
              increment={controlChildren.increment}
              incrementLabel={labels.increment + childLabel}
              isDecrementDisabled={controlChildren.isDecrementDisabled}
              isIncrementDisabled={controlChildren.isIncrementDisabled}
              name="children"
              value={controlChildren.value}
            />
          </div>
          <div className="mt-4 flex justify-between border-b border-light-gray pb-4">
            <div className="mr-4 min-w-40">{labels.infantsRestrictions}</div>
            <Incrementer
              decrement={controlInfants.decrement}
              decrementLabel={labels.decrement + infantLabel}
              increment={controlInfants.increment}
              incrementLabel={labels.increment + infantLabel}
              isDecrementDisabled={controlInfants.isDecrementDisabled}
              isIncrementDisabled={controlInfants.isIncrementDisabled}
              name="infants"
              value={controlInfants.value}
            />
          </div>
          <div className="mt-4 justify-between pb-4 text-charcoal">
            <p
              className="mr-4 min-w-40 text-legal data-[emphasize-rule=true]:font-bold"
              data-emphasize-rule={
                controlAdults.isIncrementDisabled &&
                controlChildren.isIncrementDisabled
              }
            >
              {labels.maximumTravelers}
            </p>

            <p
              className="mr-4 min-w-40 text-legal data-[emphasize-rule=true]:font-bold"
              data-emphasize-rule={
                controlChildren.value > 0 &&
                controlAdults.value === 0 &&
                controlChildren.value === MAX_CHILDREN_WITHOUT_ADULT
              }
            >
              {labels.maximumChildren}
            </p>

            <p
              className="mr-4 min-w-40 text-legal data-[emphasize-rule=true]:font-bold"
              data-emphasize-rule={controlInfants.isIncrementDisabled}
            >
              {labels.maximumInfants}
            </p>

            <div
              className="trusted-html-link mr-4 mt-3 min-w-40 text-legal"
              dangerouslySetInnerHTML={{ __html: labels.specialAssistance }}
            />
            <div
              className="trusted-html-link mr-4 min-w-40 pt-3 text-legal"
              dangerouslySetInnerHTML={{ __html: labels.needHelp }}
            />
          </div>
        </div>
      </Dropdown>
    </>
  );
};
